module.exports = __webpack_public_path__ + "img/Banner.35db32ba.png";